import React, { Component } from 'react';
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';

class Contact extends Component {
    render() {
        return <div><h1>Contact</h1></div>;
    }
};

export default Contact;